import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { isEmpty } from 'lodash';

const ConfirmationModal = ({
  closeLabel,
  confirmLabel,
  disableConfirm,
  message,
  showModal,
  title,
  onCloseFunction,
  onConfirmFunction,
  variantButtonClose,
  variantButtonConfirm
}) => {
  return (
    <Modal show={showModal} onHide={onCloseFunction}>
      {!isEmpty(title) && (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      {!isEmpty(message) && (
        <Modal.Body>
          <p>{message}</p>
        </Modal.Body>
      )}
      <Modal.Footer>
        <Button variant={variantButtonClose} onClick={onCloseFunction}>
          {closeLabel}
        </Button>
        <Button
          variant={variantButtonConfirm}
          disabled={disableConfirm}
          onClick={onConfirmFunction}
        >
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmationModal.defaultProps = {
  closeLabel: 'Close',
  confirmLabel: 'Confirm',
  disableConfirm: false,
  message: '',
  title: '',
  variantButtonClose: 'secondary',
  variantButtonConfirm: 'danger'
};

ConfirmationModal.propTypes = {
  closeLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  disableConfirm: PropTypes.bool,
  message: PropTypes.string,
  showModal: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onCloseFunction: PropTypes.func.isRequired,
  onConfirmFunction: PropTypes.func.isRequired,
  variantButtonClose: PropTypes.string,
  variantButtonConfirm: PropTypes.string
};

export default ConfirmationModal;
